angular.module('bookAndPay').controller('EditCartCtrl', ["$scope", "$state", "$window", "$http", "$timeout", "$stateParams", "DataService", "cart", function($scope, $state, $window, $http, $timeout, $stateParams, DataService, cart) {
  var buildMarketingInformation, isPrivacyPoliciesFormValid, parseMarketingInformation, setLinksTarget;
  $scope.cart = cart;
  $scope.units = DataService.units;
  $scope.currency = DataService.currency;
  parseMarketingInformation = function() {
    var errors, info, mi, rawErrs;
    info = {};
    errors = {};
    mi = $scope.cart.marketing_information || {};
    angular.forEach(mi, function(field, key) {
      if (key === 'errors') {
        return;
      }
      return info[key] = (field != null) && (field.value != null) ? field.value : '';
    });
    rawErrs = mi.errors || {};
    angular.forEach(rawErrs, function(val, key) {
      if (angular.isArray(val)) {
        return errors[key] = val;
      } else if (val != null) {
        return errors[key] = [String(val)];
      }
    });
    info.errors = errors;
    return info;
  };
  setLinksTarget = function() {
    return $timeout(function() {
      return angular.element('.privacyPolicies a').each(function(i, element) {
        return element.target = '_blank';
      });
    });
  };
  if (cart.contact_id) {
    $scope.cart.doPUT({
      contact_email: $scope.cart.contact_email
    }).then(function() {
      return $state.go('bookAndPay.processPayment', {
        uuid: cart.cart_uuid
      });
    }, function(response) {
      return $scope.isLoading = false;
    });
  } else {
    $http.get(`/gyms/${DataService.gym_id}/privacy_policies?filters[policy_context]=book_and_pay_contact_details`).then(function(response) {
      $scope.privacyPolicies = response.data.collection;
      setLinksTarget();
      return $scope.cart.privacy_policy_responses_attributes = $scope.privacyPolicies.map(function(item) {
        return {
          privacy_policy_id: item.id,
          accepted: false
        };
      });
    });
  }
  isPrivacyPoliciesFormValid = function() {
    return !$scope.cart.privacy_policy_responses_attributes || _.every($scope.cart.privacy_policy_responses_attributes, function(item) {
      return item.accepted;
    });
  };
  $scope.cartType = cart.cart_type === 'payment_only_cart' ? 'po' : void 0;
  $scope.marketingInformation = parseMarketingInformation();
  $scope.save = function() {
    $scope.cart.marketing_information = buildMarketingInformation();
    $scope.isLoading = true;
    $scope.cart.step = 'contact_info';
    return $scope.cart.save().then(function(response) {
      return $state.go('bookAndPay.processPayment', {
        uuid: cart.cart_uuid
      });
    }, function(response) {
      var base, normalized, ref, ref1;
      $scope.isLoading = false;
      if (response != null ? (ref = response.data) != null ? (ref1 = ref.marketing_information) != null ? ref1.errors : void 0 : void 0 : void 0) {
        if ((base = $scope.cart).marketing_information == null) {
          base.marketing_information = {};
        }
        $scope.cart.marketing_information.errors = response.data.marketing_information.errors;
        normalized = {};
        angular.forEach($scope.cart.marketing_information.errors, function(val, key) {
          if (angular.isArray(val)) {
            return normalized[key] = val;
          } else if (val != null) {
            return normalized[key] = [String(val)];
          }
        });
        if ($scope.marketingInformation == null) {
          $scope.marketingInformation = {};
        }
        return $scope.marketingInformation.errors = normalized;
      }
    });
  };
  $scope.isFormReady = function() {
    return !$scope.isLoading && $scope.cart.contact_phone_number && $scope.cart.contact_first_name && $scope.cart.contact_last_name && isPrivacyPoliciesFormValid();
  };
  $scope.displayTime = function() {
    return moment(cart.event_start_at, 'YYYY/MM/DD HH:mma').format('ddd, D MMM [at] h:mm');
  };
  buildMarketingInformation = function() {
    var form;
    form = {};
    if ($scope.cart.marketing_information_form.fields) {
      $scope.cart.marketing_information_form.fields.forEach(function(field) {
        if (!field.on_member) {
          return;
        }
        return form[field.id] = {
          label: field.label,
          value: $scope.marketingInformation[field.id]
        };
      });
    }
    return form;
  };
  return $scope.cancelBooking = function() {
    if ($window.confirm("Are you sure you want to cancel your booking?")) {
      return $state.go('bookAndPay.newCart', {
        uuid: cart.membership_plan_uuid,
        ct: $scope.cartType
      });
    }
  };
}]);
